import { ChatRoom } from 'lib/_types'
import { ContextSchema, SchemaDetail, schemaPath } from './types'

// Schema for ChatRoom entity
const CHAT_ROOM_SCHEMA: SchemaDetail = {
  vendor: 'space.yay',
  name: 'chatroom',
  format: 'jsonschema',
  version: '1-0-0',
}

export type ChatRoomContextSchemaData = {
  /**
   * Chat ID for chat
   */
  chat_id: number
  /**
   * Number of participants in chat room
   */
  participant_count: number
  /**
   * Unix timestamp when the last latest message was sent. Null when there is no message
   */
  last_message_at: string | null
}

export const chatRoomContextSchema = (
  data: ChatRoomContextSchemaData
): ContextSchema<ChatRoomContextSchemaData> => ({
  schema: schemaPath(CHAT_ROOM_SCHEMA),
  data,
})

export const chatRoomToChatRoomContextSchema = ({
  chatRoom,
}: {
  chatRoom?: Partial<ChatRoom>
}): ChatRoomContextSchemaData => {
  if (!chatRoom) return

  return {
    chat_id: chatRoom.id,
    last_message_at: chatRoom.last_message?.created_at?.toString() ?? '',
    participant_count: chatRoom.members?.length ?? 0,
  }
}
